module.exports = __webpack_public_path__ + "img/scene_summer_big@2x.466aa291.png";